// @flow
export { default } from './LoadingComponent.component';
